import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const inr = (paise) => `₹${((paise || 0) / 100).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

function Card({ label, value, sub, testId }) {
  return (
    <div className="bg-[#161614] p-4 lg:p-6" data-testid={testId}>
      <p className="font-mono text-[10px] tracking-[0.25em] text-[#6e6e6a]">{label}</p>
      <p className="mt-2 font-display font-extrabold text-3xl">{value}</p>
      {sub && <p className="mt-1 font-mono text-[10px] tracking-[0.15em] text-[#a3a39f]">{sub}</p>}
    </div>
  );
}

export default function AdminReports({ token }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/admin/stats`, { headers: { "X-Admin-Token": token } })
      .then((r) => r.json())
      .then(setStats)
      .catch(() => {});
  }, [token]);

  if (!stats) return <p className="mt-10 font-mono text-[11px] tracking-[0.2em] text-[#6e6e6a]">LOADING…</p>;

  const st = stats.by_status || {};
  const paidCount = (st.paid || 0) + (st.refunded || 0);

  return (
    <div className="mt-2" data-testid="admin-reports">
      <p className="font-mono text-[10px] tracking-[0.3em] text-[#6e6e6a]">PAYMENT RECONCILIATION</p>
      <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-px bg-[#2e2e2a] border border-[#2e2e2a]">
        <Card label="GROSS SALES" value={inr(stats.gross_collected_paise)} sub={`${paidCount} successful payment${paidCount === 1 ? "" : "s"}`} testId="report-gross" />
        <Card label="REFUNDS" value={inr(stats.refunds_paise)} sub={`${st.refunded || 0} refunded`} testId="report-refunds" />
        <Card label="NET COLLECTIONS" value={inr(stats.net_collected_paise)} sub="gross minus refunds" testId="report-net" />
        <Card label="OUTSTANDING" value={st.hold || 0} sub="unpaid registrations" testId="report-pending" />
      </div>

      <div className="mt-10 grid lg:grid-cols-2 gap-8">
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] text-[#6e6e6a] mb-3">BY CATEGORY (PAID)</p>
          <div className="border border-[#2e2e2a]" data-testid="report-by-category">
            {Object.entries(stats.by_category || {}).map(([cat, c]) => (
              <div key={cat} className="flex items-center justify-between px-4 py-3 border-b border-[#2e2e2a] last:border-0 font-mono text-[11px] tracking-[0.08em]">
                <span>{cat}</span>
                <span className="text-[#a3a39f]">{c.count} · {inr(c.revenue_paise)}</span>
              </div>
            ))}
            {!Object.keys(stats.by_category || {}).length && (
              <p className="px-4 py-3 font-mono text-[11px] text-[#6e6e6a]">No paid registrations yet</p>
            )}
          </div>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] text-[#6e6e6a] mb-3">BY PROTECTION PLAN (PAID)</p>
          <div className="border border-[#2e2e2a]" data-testid="report-by-addon">
            {Object.entries(stats.by_addon || {}).map(([addon, c]) => (
              <div key={addon} className="flex items-center justify-between px-4 py-3 border-b border-[#2e2e2a] last:border-0 font-mono text-[11px] tracking-[0.08em]">
                <span className="uppercase">{addon.replace("_", " ")}</span>
                <span className="text-[#a3a39f]">{c.count} · {inr(c.revenue_paise)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <p className="mt-8 font-mono text-[10px] tracking-[0.08em] text-[#6e6e6a] leading-relaxed max-w-2xl" data-testid="report-note">
        Payment status here comes only from PayU's signed server-to-server callback (or a manual MARK PAID). These figures reconcile
        our booking records; settle and cross-check payouts in your PayU merchant dashboard under Transactions.
      </p>
    </div>
  );
}
